import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import {
  AssignmentPreview,
  GetSubmissionResponse,
  SubmissionResponse,
  SubmissionResult,
  SaveAnswerDto,
} from './student-assignment.models';

@Injectable({
  providedIn: 'root',
})
export class StudentAssignmentApiService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiUrl}/assignments/share`;

  /**
   * Get assignment preview (public - no auth required)
   */
  getPreview(shareCode: string): Observable<AssignmentPreview> {
    return this.http.get<AssignmentPreview>(`${this.apiUrl}/${shareCode}`);
  }

  /**
   * Start taking the assignment (creates submission)
   */
  startSubmission(shareCode: string): Observable<SubmissionResponse> {
    return this.http.post<SubmissionResponse>(
      `${this.apiUrl}/${shareCode}/start`,
      {}
    );
  }

  /**
   * Get current submission state.
   * Returns { started: true, submission: {...} } if student has started,
   * or { started: false, submission: null } if not.
   */
  getSubmission(shareCode: string): Observable<GetSubmissionResponse> {
    return this.http.get<GetSubmissionResponse>(
      `${this.apiUrl}/${shareCode}/submission`
    );
  }

  /**
   * Save answer for a question
   */
  saveAnswer(
    shareCode: string,
    questionId: string,
    dto: SaveAnswerDto
  ): Observable<SubmissionResponse> {
    return this.http.put<SubmissionResponse>(
      `${this.apiUrl}/${shareCode}/answer/${questionId}`,
      dto
    );
  }

  /**
   * Submit the assignment for grading
   */
  submit(shareCode: string): Observable<SubmissionResult> {
    return this.http.post<SubmissionResult>(
      `${this.apiUrl}/${shareCode}/submit`,
      {}
    );
  }

  /**
   * Get graded result
   */
  getResult(shareCode: string): Observable<SubmissionResult> {
    return this.http.get<SubmissionResult>(
      `${this.apiUrl}/${shareCode}/result`
    );
  }
}
